/**
 * File lottie/arrow.js
 * Handles setting scroll arrow animation
 */

const lottieArrows = document.querySelectorAll('.lottie-arrow');

if (lottieArrows.length > 0 && typeof lottie == 'object' && typeof theme !== 'undefined') {
  for (let i = 0; i < lottieArrows.length; i++) {
    if (lottieArrows[i]) {
      lottie.loadAnimation({
        container: lottieArrows[i],
        path: theme.path + '/json/arrow.json',
        renderer: 'svg',
        loop: false,
        autoplay: true,
      });
    }
  }
}
